"use client";

import { useEffect, useState } from "react";
import classNames from "classnames";

import { Accordion } from "@/components//Accordion";
import { Typography } from "@/components/Typography";

import { TabsProps } from "./types";

import { useAccordion } from "@/hooks/useAccordion";

import "./styles.scss";

export const Tabs = ({ tabsData, light }: TabsProps) => {
  const [currentTab, setCurrentTab] = useState("1");
  const { activeItem, toggleOpen, setActiveItem } = useAccordion();

  const classnames = classNames(`Tabs`, {
    ["Tabs--light"]: light,
  });

  useEffect(() => {
    setActiveItem(0);
  }, [currentTab]);

  const handleTabClick = (id: string) => setCurrentTab(id);

  return (
    <div className={classnames} data-testid="Tabs">
      <ul className="nav">
        {tabsData.map((tab, i) => (
          <li
            tabIndex={1}
            className={`tab button button--secondary button--large ${
              currentTab === `${tab.id}` ? "active" : ""
            } `}
            key={i}
            id={`${tab.id}`}
            onClick={() => handleTabClick(`${tab.id}`)}
          >
            <Typography Tag="p" classname="tab-text-mobile">
              {tab.labelMobile}
            </Typography>

            <Typography Tag="p" classname="tab-text">
              {tab.label}
            </Typography>
          </li>
        ))}
      </ul>
      <div className="content">
        {tabsData?.map((tab, i) => (
          <div key={i}>
            {currentTab === `${tab.id}` && (
              <div>
                {tab?.type === "accordion" ? (
                  <>
                    {Array.isArray(tab.content) &&
                      tab.content.map((item, i) => (
                        <Accordion
                          key={i}
                          title={item.title}
                          isActiveItem={activeItem === i}
                          toggle={toggleOpen(i)}
                          allClosed
                          accordionIndex={i}
                        >
                          {item.richtext.map((item, i) => (
                            <Typography key={i} Tag={item.tag}>
                              {item.list
                                ? item.list.map((e, i) => (
                                    <li key={i}>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: e["item"] as string,
                                        }}
                                      ></span>
                                    </li>
                                  ))
                                : item.content}
                            </Typography>
                          ))}
                        </Accordion>
                      ))}
                  </>
                ) : (
                  <>{!Array.isArray(tab.content) && <p>{tab.content}</p>}</>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
